// extracted by mini-css-extract-plugin
export default {"container":"ProjectPackage_container__+WoOT","title":"ProjectPackage_title__0iPDF","addPackageBtn":"ProjectPackage_addPackageBtn__kR+2r","head":"ProjectPackage_head__8mbkD"};